import moment from 'moment';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Card, Tabs, Tab, Button, Image, Container } from 'react-bootstrap';

import Loading from '../Loading';
import { applyPortalTextColor, dispatchModal, formatToFixed } from '../../utils/helper';
import { editSignedContractService, addSignedContractService } from '../../services/signedContractsService';
import { getBookingConfirmationDetailsService, printSignedBookingService } from '../../services/bookingsService';
import './index.scss';
import {
    ConfirmationHeader,
    CustomModal,
    InfoRow,
    ListAddons,
    ListAmenities,
    ListPayments,
    ListSegments,
    ListVehicles,
    PriceRow,
    SectionCard,
    VehicleOnSite,
} from '../Reusable';

export const PoweredByFooter = () => (
    <div className="d-flex justify-content-end p-4">
        <Image
            src={'https://storage.googleapis.com/the-bus-network-bucket/default/Powered-By-TBN-Logo.png'}
            className="m-0 p-0"
        />
    </div>
);

export const CustomerInfoSection = ({ contactDetails, settings }) => {
    return (
        <Col lg={6} md={6} sm={12} xs={12}>
            <SectionCard title="Customer Information" settings={settings}>
                <div className="info-wrapper">
                    {[
                        contactDetails.organization,
                        contactDetails.fullName,
                        contactDetails.jobTitle,
                        contactDetails.department,
                        contactDetails.email,
                        contactDetails.phoneWork ||
                            contactDetails.phoneMobile ||
                            contactDetails.phoneAlt ||
                            contactDetails.phoneHome ||
                            '',
                    ].map((val, idx) =>
                        val ? (
                            <div key={idx}>
                                <span className="portal-text">
                                    <h4 className="title-info">{val}</h4>
                                </span>
                            </div>
                        ) : null
                    )}
                </div>
            </SectionCard>
        </Col>
    );
};

export const FinancialsAndContactSection = ({ bookingDetails, totals, settings }) => {
    return (
        <Col lg={6} md={6} sm={12} xs={12}>
            <Row>
                <Col xl={12} className="content-waraper">
                    <div className="h-100">
                        <SectionCard title="Financials & Sales" settings={settings}>
                            {bookingDetails.documentTypeID == 1 && (
                                <InfoRow
                                    label="Trip Reference:"
                                    value={bookingDetails.tripReference}
                                    settings={settings}
                                    show={!!bookingDetails.tripReference}
                                />
                            )}
                            <PriceRow
                                label="Total Vehicle Price:"
                                value={totals.vehiclesTotal}
                                settings={settings}
                                show={bookingDetails.documentTypeID == 1}
                            />
                            <PriceRow
                                label="Total Addon Price:"
                                value={totals.addonsTotal}
                                settings={settings}
                                show={bookingDetails.documentTypeID == 1 && totals.addonsTotal > 0}
                            />
                            <PriceRow
                                label="Total Discount:"
                                value={totals.totalDiscount}
                                settings={settings}
                                show={bookingDetails.documentTypeID == 1 && totals.totalDiscount > 0}
                            />
                            <PriceRow label="Booking Total:" value={totals.bookingTotal} settings={settings} />
                            <PriceRow
                                label="Total Before Tax:"
                                value={bookingDetails.totalBeforeTax}
                                settings={settings}
                            />
                            <PriceRow label="Tax:" value={bookingDetails.totalTax} settings={settings} />
                            <PriceRow
                                label="Total After Tax:"
                                value={bookingDetails.totalAfterTax}
                                settings={settings}
                            />
                        </SectionCard>
                    </div>
                </Col>

                <Col xl={6} lg={12} md={12} sm={12} className="content-waraper">
                    <div className="h-100">
                        <SectionCard title="SalesPerson" settings={settings} minHeight="128px">
                            <div className="info-wrapper">
                                <span className="total-text total-text-left">
                                    <p>{bookingDetails.salesPerson || ''}</p>
                                </span>
                            </div>
                        </SectionCard>
                    </div>
                </Col>
                <Col xl={6} lg={12} md={12} sm={12} className="content-waraper">
                    <div className="h-100">
                        <SectionCard title="Contact" settings={settings}>
                            <div className="info-wrapper">
                                <span className="total-text total-text-left">
                                    <p>{bookingDetails.salesPersonContact || ''}</p>
                                </span>
                            </div>
                        </SectionCard>
                    </div>
                </Col>
            </Row>
        </Col>
    );
};

export const ItineraryTabsSection = ({ routeData, bookingDetails, settings }) => {
    return (
        <Card className="card-wrapper">
            <Card.Body className="card-wrapper-box" style={{ backgroundColor: settings.sectionColor }}>
                <Tabs
                    className="card-header-tabs-box"
                    defaultActiveKey="1"
                    style={{ backgroundColor: settings.sectionColor }}
                >
                    {routeData.map((data, i) => (
                        <Tab
                            key={i + 1}
                            eventKey={i + 1}
                            style={{ backgroundColor: settings.sectionColor }}
                            title={data.routeDescription || `Route ${i + 1}`}
                        >
                            <Col xs={12} className="d-flex justify-content-center p-0">
                                <SectionCard title="Vehicle(S)" settings={settings} className="w-100">
                                    <div className="booking-wrap">
                                        {Array.isArray(data.vehicleData) && data.vehicleData.length > 0 ? (
                                            data.vehicleData.map((v) => (
                                                <ListVehicles
                                                    key={v.id}
                                                    {...v}
                                                    documentTypeID={bookingDetails.documentTypeID}
                                                />
                                            ))
                                        ) : (
                                            <div className="portal-text">NO DETAILS FOUND</div>
                                        )}
                                    </div>
                                </SectionCard>
                            </Col>

                            {bookingDetails.documentTypeID == 1 &&
                                Array.isArray(data.addonData) &&
                                data.addonData.length > 0 && (
                                    <Col xs={12} className="d-flex justify-content-center p-0">
                                        <SectionCard title="ADD ONS & EXTRAS" settings={settings} className="w-100">
                                            <div className="booking-wrap">
                                                {data.addonData.map((addon) => (
                                                    <ListAddons key={addon.id} {...addon} quantity={addon.cost} />
                                                ))}
                                            </div>
                                        </SectionCard>
                                    </Col>
                                )}

                            {Array.isArray(data.amenitiesAndInclusionsData) &&
                                data.amenitiesAndInclusionsData.length > 0 && (
                                    <Col xs={12} className="d-flex justify-content-center p-0">
                                        <SectionCard
                                            title="Amenities & Inclusions"
                                            settings={settings}
                                            className="w-100"
                                        >
                                            <div className="booking-wrap">
                                                {data.amenitiesAndInclusionsData.map((item, idx) => (
                                                    <ListAmenities key={idx} description={item.description} />
                                                ))}
                                            </div>
                                        </SectionCard>
                                    </Col>
                                )}

                            <Col xs={12} className="d-flex justify-content-center p-0">
                                <SectionCard title="Itinerary" settings={settings} className="w-100">
                                    <div className="booking-wrap">
                                        {Array.isArray(data.segmentData) && data.segmentData.length > 0 ? (
                                            <>
                                                {data.vehicleOnSite && (
                                                    <VehicleOnSite
                                                        arrivalTime={data.vehicleOnSite.arrivalTime}
                                                        destinationAddress={data.vehicleOnSite.destinationAddress}
                                                    />
                                                )}
                                                {(data.tripSegments || []).map((seg, idx) => (
                                                    <ListSegments key={idx} {...seg} />
                                                ))}
                                            </>
                                        ) : (
                                            <div className="portal-text">NO DETAILS FOUND</div>
                                        )}
                                    </div>
                                </SectionCard>
                            </Col>
                        </Tab>
                    ))}
                </Tabs>
            </Card.Body>
        </Card>
    );
};

export const PaymentsDueSection = ({ bookingDetails, settings }) => {
    const isInvoiced = !!bookingDetails.trig_invoiceID;
    return (
        <Col xs={12} className="d-flex justify-content-center p-0">
            <SectionCard title="PAYMENT(S) DUE" settings={settings} className="w-100">
                {!bookingDetails.hideDepositSection && (
                    <ListPayments
                        name="Deposit"
                        amount={bookingDetails.depositAmount}
                        text={bookingDetails.depositText}
                        isInvoiced={isInvoiced}
                    />
                )}
                {!bookingDetails.hideFinalPaymentSection && (
                    <ListPayments
                        name="Amount Outstanding"
                        amount={bookingDetails.amountOutstanding}
                        text={bookingDetails.finalPaymentText}
                        isInvoiced={isInvoiced}
                    />
                )}
            </SectionCard>
        </Col>
    );
};

export const SignatureActionSection = ({
    formData,
    signature,
    settings,
    loading,
    onPrint,
    onCheckout,
    onAcceptClick,
    bookingDetails,
}) => {
    return (
        <>
            {formData && !formData.name ? (
                <div className="button-head">
                    <Button
                        className="mt-3"
                        style={{
                            backgroundColor: loading ? '#646262' : settings.buttonColor,
                            borderColor: 'transparent',
                        }}
                        onClick={onAcceptClick}
                    >
                        ACCEPT & CONTINUE
                    </Button>
                </div>
            ) : (
                <>
                    <div className="accept-title m-2">
                        <div
                            className="title"
                            dangerouslySetInnerHTML={{
                                __html: settings.customerPortalSignatureInstructions,
                            }}
                        />
                    </div>
                    <div className="sign-box">
                        <SectionCard title="Signature" settings={settings} className="w-100">
                            <div className="booking-wrap portal-text" dangerouslySetInnerHTML={{ __html: signature }} />
                        </SectionCard>
                        <SectionCard title="Printed Name" settings={settings} className="w-100">
                            <div className="booking-wrap portal-text">{formData.name}</div>
                        </SectionCard>
                        <SectionCard title="Date" settings={settings} className="w-100">
                            <div className="booking-wrap portal-text">{moment().format('MM/DD/YYYY')}</div>
                        </SectionCard>
                    </div>
                    <div className="print-btn mt-2">
                        <Button
                            className="btn-primary ml-2"
                            style={{
                                backgroundColor: loading ? '#646262' : settings.buttonColor,
                                borderColor: 'transparent',
                            }}
                            onClick={onPrint}
                        >
                            DOWNLOAD SIGNED CONTRACT
                        </Button>
                        {bookingDetails &&
                            Number(bookingDetails.paymentTermID) === 1 &&
                            Number(bookingDetails.amountOutstanding) > 0 &&
                            !bookingDetails.trig_invoiceID &&
                            !bookingDetails.disablePayment && (
                                <Button
                                    className="btn-primary ml-2"
                                    style={{
                                        backgroundColor: loading ? '#646262' : settings.buttonColor,
                                        borderColor: 'transparent',
                                    }}
                                    onClick={onCheckout}
                                >
                                    CHECKOUT PAGE
                                </Button>
                            )}
                    </div>
                </>
            )}
        </>
    );
};

const BookingConfirmation = (props) => {
    const history = useHistory();

    const queryObj = useMemo(() => Object.fromEntries(new URLSearchParams(window.location.search)), []);
    const { bid: bookingId, ts, signedContractId: qSignedContractId } = queryObj;
    const signedContractId = props?.location?.state?.signedContractId || qSignedContractId;

    const { register, handleSubmit } = useForm();
    const [state, setState] = useState({
        loading: true,
        accept: false,
        signature: '',
        contractId: null,
        formData: { name: '' },
        data: {
            bookingDetails: {},
            contactDetails: {},
            routeData: [],
            tripSetting: {},
            totals: {},
        },
    });

    useEffect(() => {
        let isMounted = true;
        const fetchData = async () => {
            try {
                const booking = await getBookingConfirmationDetailsService(bookingId, ts);

                if (!isMounted) return;

                if (booking && Object.keys(booking.data).length > 0) {
                    const { details, contactDetail, routeData, accountSettings } = booking.data;
                    const root = document.documentElement;
                    root?.style.setProperty('--background-color', accountSettings.mainColor);
                    root?.style.setProperty('--background-color-active', accountSettings.textColor);
                    applyPortalTextColor(accountSettings.portalTextColor);

                    setState((prev) => ({
                        ...prev,
                        loading: false,
                        data: {
                            bookingDetails: details,
                            contactDetails: contactDetail,
                            routeData: routeData,
                            tripSetting: accountSettings,
                            totals: {
                                bookingTotal: details.totalAfterTax,
                                vehiclesTotal: formatToFixed(details.vehicleTotal),
                                addonsTotal: formatToFixed(details.addonTotal),
                                totalDiscount: formatToFixed(details.totalDiscount),
                            },
                        },
                    }));
                } else {
                    dispatchModal('Booking Record Not Found.');
                    setState((prev) => ({ ...prev, loading: false }));
                }
            } catch (error) {
                console.error(error);
                setState((prev) => ({ ...prev, loading: false }));
            }
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [bookingId, ts]);

    const handlePrint = async () => {
        try {
            setState((prev) => ({ ...prev, loading: true }));
            const pdfData = await printSignedBookingService(
                bookingId,
                state.contractId || signedContractId,
                state.data.bookingDetails.companyId
            );
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([pdfData.data], { type: 'application/pdf' }));
            link.download = `Booking (${state.data.bookingDetails.bookingId})`;
            link.click();
        } catch (e) {
            console.error(e);
        } finally {
            setState((prev) => ({ ...prev, loading: false }));
        }
    };

    const handleAcceptSubmit = async (e) => {
        e.preventDefault();
        await handleSubmit(async (formData) => {
            try {
                setState((prev) => ({ ...prev, loading: true, formData: { name: formData.name } }));
                const timestamp = moment.utc().format('YYYY-MM-DDTHH:mm:00');
                const { companyId } = state.data.bookingDetails;

                if (signedContractId) {
                    await editSignedContractService(
                        signedContractId,
                        {
                            bookingConfirmationSignature: formData.name,
                            bookingConfirmationSignedAt: timestamp,
                            bookingID: bookingId,
                            notification: true,
                        },
                        companyId
                    );
                } else {
                    const res = await addSignedContractService(
                        {
                            bookingID: bookingId,
                            termsConditionsAutoAccepted: 1,
                            bookingConfirmationSignature: formData.name,
                            bookingConfirmationSignedAt: timestamp,
                            termsConditionsAutoAcceptedAt: timestamp,
                            disclaimerAutoAccepted: 1,
                            disclaimerAutoAcceptedAt: timestamp,
                            notification: true,
                        },
                        companyId
                    );
                    if (res?.data?.id) setState((prev) => ({ ...prev, contractId: res.data.id }));
                }

                setState((prev) => ({
                    ...prev,
                    loading: false,
                    accept: false,
                    signature: `<i style="margin-bottom: 0;font-size:19px; font-family: 'Brush Script MT';" >${formData.name} </i>`,
                }));
            } catch (e) {
                console.error(e);
                setState((prev) => ({ ...prev, loading: false, accept: false }));
            }
        })();
    };

    const { loading, accept, signature, formData, data } = state;
    const { bookingDetails, contactDetails, routeData, tripSetting, totals } = data;

    if (loading) return <Loading loading={loading} />;

    return (
        <div>
            <div className="top-header">
                <ConfirmationHeader tripSetting={tripSetting} bookingDisplayId={bookingDetails.bookingId} />

                <div className="background-box-color">
                    <div className="background-wrapper" style={{ backgroundColor: tripSetting.sectionColor }}>
                        <Container fluid>
                            <Row>
                                {/* Customer Info */}
                                <CustomerInfoSection contactDetails={contactDetails} settings={tripSetting} />

                                {/* Financials & Sales */}
                                <FinancialsAndContactSection
                                    bookingDetails={bookingDetails}
                                    totals={totals}
                                    settings={tripSetting}
                                />
                            </Row>

                            {/* Itinerary Tabs */}
                            <ItineraryTabsSection
                                routeData={routeData}
                                bookingDetails={bookingDetails}
                                settings={tripSetting}
                            />

                            {/* Payments Due */}
                            <PaymentsDueSection bookingDetails={bookingDetails} settings={tripSetting} />

                            {/* Signature Action */}
                            <SignatureActionSection
                                formData={formData}
                                signature={signature}
                                settings={tripSetting}
                                loading={loading}
                                bookingDetails={bookingDetails}
                                onAcceptClick={() => setState((p) => ({ ...p, accept: true }))}
                                onPrint={handlePrint}
                                onCheckout={() =>
                                    history.push(
                                        `/p/booking-payment?bid=${bookingId}&ts=${new Date(bookingDetails?.createdAt).valueOf()}&contarctId=${signedContractId ? signedContractId : state.contractId}`
                                    )
                                }
                            />

                            {accept && (
                                <CustomModal
                                    show={accept}
                                    onHide={() => setState((p) => ({ ...p, accept: false }))}
                                    settings={tripSetting}
                                    onSubmit={handleAcceptSubmit}
                                    loading={loading}
                                    register={register}
                                    type="Signature"
                                />
                            )}
                        </Container>
                    </div>
                </div>
            </div>
            <PoweredByFooter />
        </div>
    );
};

export default React.memo(BookingConfirmation, () => true);
